import React, { useCallback } from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import { TouchableUnderlineMediumText } from ".";
import { useSelector } from "react-redux";
import { getHasCampaignReviews } from "@microdoing/shared/services/userCampaign/selectors";
import { Box } from "./Box/MainBox/MainBox";
import theme from "app/Theme/Theme";

interface NavList {
  name: string;
  value: string;
  lineColor: string;
}

interface Props {
  children: JSX.Element;
  navList: NavList[] | [];
  onNavSelected(value: string, index: number): void;
  tabSelectedIndex: number;
}

const styles = StyleSheet.create({
  listMain: {
    marginBottom: theme.spacing.xm,
    flexDirection: "row",
  },
  navList: {
    marginRight: 20,
  },
});

const RedirectNavig = ({
  children,
  navList,
  onNavSelected,
  tabSelectedIndex,
}: Props) => {
  const hasReview = useSelector(getHasCampaignReviews);

  const onChangeTab = useCallback(
    (data, index) => () => {
      onNavSelected(data.value, index);
    },
    [onNavSelected],
  );

  const displayNavigation = () => {
    return navList.map((element, index) => {
      const isSelected = index === tabSelectedIndex;
      return (
        <TouchableUnderlineMediumText
          style={styles.navList}
          key={index}
          text={element?.name}
          underlineColor={element?.lineColor}
          onPress={onChangeTab(element, index)}
          isSelected={isSelected}
        />
      );
    });
  };

  return (
    <Box flex={1}>
      {hasReview && (
        <Box>
          <ScrollView style={[styles.listMain]} horizontal>
            {displayNavigation()}
          </ScrollView>
        </Box>
      )}
      <Box flex={1}>{children}</Box>
    </Box>
  );
};

export { RedirectNavig };
